<template>
	<div class="content-wrapper txn-page">
		<nav aria-label="breadcrumb" class="txn-page__breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item active">Transactions</li>
				<div class="ml-auto">
					<button v-can="'transactions.bulk_download_reciept'" @click="downloadTransaction()"
						class="btn btn-sm btn-outline-primary"><i class="fa fa-book"></i> Download Receipt</button>

					<!-- <a v-can="'transactions.bulk_download'" target="_blank"
                        :href="$store.getters.apiUrl + 'downloadTransactionDetails?from_date=' + meta.from_date + '&to_date=' + meta.to_date + '&transaction_type=' + meta.transaction_type + '&status=' + meta.status + '&payment_mode_id=' + meta.payment_mode_id + '&user_id=' + meta.user_id + '&customer_id=' + meta.customer_id"
                        class="btn btn-sm btn-outline-success">
                        <i class="fa fa-download"></i> Download Transactions
                    </a> -->
					<a v-can="'transactions.bulk_download'" :href="downloadUrl" @click.prevent="validateDateRange"
						class="btn btn-sm btn-outline-success"> <i class="fa fa-download"></i> Download Transactions
					</a>
				</div>
			</ol>
		</nav>
		<section class="content txn-page__content pb-0">
			<div class="container-fluid txn-page__container">
				<div class="row justify-content-md-center txn-page__row">
					<div class="col-sm-12 txn-page__col">
						<div class="card txn-page__card mb-0">
							<div class="card-header txn-list-header py-1 flex-shrink-0">
								<h3 class="card-title mb-0 mr-2">
									Transactions
									<small v-if="meta.totalRows" class="text-muted font-weight-normal">
										({{ meta.totalRows }})
									</small>
								</h3>
								<div class="txn-list-header__actions">
									<span class="txn-total-inline">
										Total <strong>{{ formatCurrency(total) }}</strong>
									</span>
									<div class="txn-sort-pills">
										<button type="button" class="txn-sort-pill"
											:class="sortPillClass('transaction_no')" @click="sort('transaction_no')">
											No <i :class="sortIconClass('transaction_no')"></i>
										</button>
										<button type="button" class="txn-sort-pill"
											:class="sortPillClass('transaction_date_time')"
											@click="sort('transaction_date_time')">
											Date <i :class="sortIconClass('transaction_date_time')"></i>
										</button>
										<button type="button" class="txn-sort-pill"
											:class="sortPillClass('transaction_type')"
											@click="sort('transaction_type')">
											Type <i :class="sortIconClass('transaction_type')"></i>
										</button>
									</div>
								</div>
							</div>
							<div class="card-body py-1 px-2 txn-page__body">
								<div class="txn-filters txn-page__filters">
									<div class="txn-filters__bar">
										<button type="button"
											class="btn btn-sm txn-filters__toggle"
											:class="filtersOpen ? 'btn-primary' : 'btn-outline-secondary'"
											@click="filtersOpen = !filtersOpen"
											:aria-expanded="filtersOpen">
											<i class="fas fa-filter mr-1"></i>
											{{ filtersOpen ? 'Hide' : 'Filters' }}
											<span v-if="activeFilterCount" class="badge badge-light ml-1">{{
												activeFilterCount }}</span>
										</button>
										<div class="txn-filters__search">
											<i class="fas fa-search txn-filters__search-icon"></i>
											<input type="text" v-model="meta.search"
												class="form-control form-control-sm" placeholder="Search T.No, ref, note…"
												@keyup.enter="search" />
										</div>
										<div class="txn-filters__bar-actions">
											<button type="button" class="btn btn-sm btn-primary px-2" @click="search"
												title="Search">
												<i class="fa fa-search"></i>
											</button>
											<button type="button" class="btn btn-sm btn-outline-secondary px-2"
												@click="resetSearch" title="Reset all">
												<i class="fa fa-times"></i>
											</button>
										</div>
									</div>

									<div v-if="!filtersOpen && activeFilterChips.length" class="txn-filters__chips">
										<span v-for="chip in activeFilterChips" :key="chip.key"
											class="txn-filter-chip">
											<span class="txn-filter-chip__label">{{ chip.label }}</span>
											<span class="txn-filter-chip__value">{{ chip.value }}</span>
											<button type="button" class="txn-filter-chip__clear"
												@click="clearFilter(chip.key)" aria-label="Clear">&times;</button>
										</span>
									</div>

									<div v-show="filtersOpen" class="txn-filters__panel">
										<div class="txn-filters__grid">
											<div class="txn-filters__field">
												<label class="txn-filters__label">From</label>
												<input class="form-control form-control-sm" type="date"
													v-model="meta.from_date" />
											</div>
											<div class="txn-filters__field">
												<label class="txn-filters__label">To</label>
												<input class="form-control form-control-sm" type="date"
													v-model="meta.to_date" />
											</div>
											<div class="txn-filters__field">
												<label class="txn-filters__label">Type</label>
												<select class="form-control form-control-sm"
													v-model="meta.transaction_type">
													<option value="">All</option>
													<option value="Deposit">Deposit</option>
													<option value="Withdraw">Withdraw</option>
													<option value="TDS">TDS</option>
													<option value="BuyIn">BuyIn</option>
													<option value="CashOut">CashOut</option>
												</select>
											</div>
											<div class="txn-filters__field">
												<label class="txn-filters__label">Status</label>
												<select class="form-control form-control-sm" v-model="meta.status">
													<option value="">All</option>
													<option value="Approved">Approved</option>
													<option value="Pending">Pending</option>
													<option value="Rejected">Rejected</option>
												</select>
											</div>
											<div class="txn-filters__field">
												<label class="txn-filters__label">Mode</label>
												<select class="form-control form-control-sm"
													v-model="meta.payment_mode_id">
													<option value="">All</option>
													<option v-for="(payment_mode, key) in payment_modes" :key="key"
														:value="payment_mode.payment_mode_id">
														{{ payment_mode.payment_mode }}
													</option>
												</select>
											</div>
											<div class="txn-filters__field">
												<label class="txn-filters__label">User</label>
												<select class="form-control form-control-sm" v-model="meta.user_id">
													<option value="">All</option>
													<option v-for="(user, key) in users" :key="key"
														:value="user.user_id">{{ user.name }}</option>
												</select>
											</div>
											<div class="txn-filters__field" v-can="'global_dashboard.view'">
												<label class="txn-filters__label">Branch</label>
												<select class="form-control form-control-sm" v-model="meta.branch_id">
													<option value="">All</option>
													<option v-for="(branch, key) in branches" :key="key"
														:value="branch.branch_id">{{ branch.branch_name }}</option>
												</select>
											</div>
											<div class="txn-filters__field">
												<label class="txn-filters__label">Customer</label>
												<Customer :class="{ 'is-invalid': errors.customer_id }"
													:customClass="{ 'is-invalid': errors.customer_id }"
													:initialize="meta.customer_name"
													@selectCustomer="selectCustomer($event)" ref="customer_id" />
											</div>
										</div>
									</div>
								</div>

								<div class="transaction-card-list">
									<div v-if="listLoading" class="txn-card-grid">
										<div v-for="n in 6" :key="'skel-' + n" class="txn-card-grid__item">
											<div class="txn-card txn-card--skeleton" aria-hidden="true">
												<div class="txn-card__top">
													<div class="txn-skeleton txn-skeleton--badge"></div>
													<div class="txn-skeleton txn-skeleton--amount"></div>
												</div>
												<div class="txn-skeleton txn-skeleton--line mb-2"></div>
												<div class="txn-skeleton txn-skeleton--line-sm mb-3"></div>
												<div class="txn-card__customer txn-card__customer--skeleton mb-2">
													<div class="txn-skeleton txn-skeleton--avatar"></div>
													<div class="flex-grow-1">
														<div class="txn-skeleton txn-skeleton--line mb-1"></div>
														<div class="txn-skeleton txn-skeleton--line-sm"></div>
													</div>
												</div>
												<div class="txn-card__details">
													<div class="txn-skeleton txn-skeleton--detail" v-for="d in 4" :key="d"></div>
												</div>
											</div>
										</div>
									</div>
									<div v-else-if="transactions.length <= 0" class="txn-empty py-3">
										<p class="text-muted mb-0 small">No records found</p>
									</div>
									<div v-else class="txn-card-grid">
										<div v-for="(transaction, key) in transactions"
											:key="transaction.transaction_id"
											class="txn-card-grid__item">
											<div class="txn-card txn-card--clickable"
												:class="typeCardClass(transaction.transaction_type)"
												role="button" tabindex="0"
												@click="view_transaction(transaction)"
												@keyup.enter="view_transaction(transaction)">
												<div class="txn-card__top">
													<div class="txn-card__badges">
														<span class="txn-type">{{ transaction.transaction_type }}</span>
														<span class="badge badge-pill"
															:class="statusBadgeClass(transaction.status)">
															{{ transaction.status }}
														</span>
													</div>
													<div class="txn-card__amount">
														{{ formatCurrency(transaction.amount) }}
													</div>
												</div>

												<span class="txn-card__no">{{ transaction.transaction_no }}</span>
												<div class="txn-card__index text-muted">#{{ meta.from + key }}</div>

												<div class="txn-card__customer">
													<div class="txn-card__avatar">
														<span v-if="customerInitial(transaction)">{{ customerInitial(transaction) }}</span>
													</div>
													<div class="txn-card__customer-text">
														<div v-if="transaction?.customer?.customer_no" class="txn-card__cust-no">
															{{ transaction.customer.customer_no }}
														</div>
														<div v-if="transaction?.customer?.customer_name"
															class="txn-card__cust-name text-truncate"
															:title="transaction.customer.customer_name">
															{{ transaction.customer.customer_name }}
														</div>
													</div>
												</div>

												<div class="txn-card__details">
													<div class="txn-detail">
														<span class="txn-detail__label">Date</span>
														<span class="txn-detail__value">
															{{ $formatDate(transaction.transaction_date_time, "india") }}
														</span>
													</div>
													<div v-if="transaction?.payment_mode?.payment_mode" class="txn-detail">
														<span class="txn-detail__label">Mode</span>
														<span class="txn-detail__value">
															{{ transaction.payment_mode.payment_mode }}
														</span>
													</div>
													<div v-if="transaction?.user?.name" class="txn-detail txn-detail--full">
														<span class="txn-detail__label">User</span>
														<span class="txn-detail__value text-truncate"
															:title="transaction.user.name">
															{{ transaction.user.name }}
														</span>
													</div>
													<div v-if="transaction.reference_id" class="txn-detail txn-detail--full">
														<span class="txn-detail__label">Reference No</span>
														<span class="txn-detail__value text-truncate"
															:title="transaction.reference_id">
															{{ transaction.reference_id }}
														</span>
													</div>
												</div>

												<p v-if="transaction.note" class="txn-card__note text-truncate"
													:title="transaction.note">
													{{ transaction.note }}
												</p>

												<div class="txn-card__footer">
													<a v-if="transaction.status === 'Approved'"
														v-can="'transactions.download'" target="_blank"
														:href="$store.getters.pdfUrl + 'api/downloadTransaction?transaction_id=' + transaction.transaction_id"
														class="btn btn-sm btn-outline-primary btn-block"
														@click.stop>
														<i class="fas fa-download mr-1"></i> Download receipt
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="card-footer py-1 txn-page__footer flex-shrink-0">
								<div class="txn-pagination-bar">
									<div class="txn-pagination-bar__info text-muted small">
										<span>Page <strong>{{ meta.page }}</strong> of
											<strong>{{ meta.lastPage || 1 }}</strong></span>
										<span v-if="meta.totalRows" class="ml-2">
											· {{ meta.from }}–{{ paginationTo }} of {{ meta.totalRows }}
										</span>
									</div>
									<Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage"
										:currentPage="meta.page" @pagechanged="onPageChange" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<TransactionDetailModal ref="transactionModal" @updated="onTransactionUpdated" />
	</div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import TransactionDetailModal from "@/components/TransactionDetailModal.vue";
let Customer = require("../../components/Customer.vue").default;
export default {
	name: "Transactions.Index",
	components: { Pagination, Customer, TransactionDetailModal },
	data() {
		return {
			status: true,
			meta: {
				from_date: "",
				to_date: "",
				transaction_type: "",
				status: "",
				customer_id: "",
				customer_name: "",
				user_id: "",
				payment_mode_id: "",
				order_by: "desc",
				keyword: "transaction_id",
				per_page: 50,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				trashed: false,
				branch_id: this.$store.getters.user.branch_id,
			},
			total: 0,
			users: [],
			customers: [],
			transactions: [],
			payment_modes: [],
			errors: [],
			branches: [],
			filtersOpen: false,
			listLoading: false,
		};
	},

	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.index();
			vm.getUsers();
			vm.getBranches();
			if (to.query.transaction_id) {
				vm.$nextTick(() => {
					vm.$refs.transactionModal.open(to.query.transaction_id);
					vm.$router.replace({ path: to.path, query: {} }).catch(() => {});
				});
			}
		});
	},

	computed: {
		downloadUrl() {
			const { from_date, to_date, transaction_type, status, payment_mode_id, user_id, customer_id, branch_id } = this.meta;
			return `${this.$store.getters.apiUrl}downloadTransactionDetails?from_date=${from_date}&to_date=${to_date}&transaction_type=${transaction_type}&status=${status}&payment_mode_id=${payment_mode_id}&user_id=${user_id}&customer_id=${customer_id}&branch_id=${branch_id}`;
		},

		activeFilterChips() {
			const vm = this;
			const chips = [];
			if (vm.meta.from_date) chips.push({ key: "from_date", label: "From", value: vm.meta.from_date });
			if (vm.meta.to_date) chips.push({ key: "to_date", label: "To", value: vm.meta.to_date });
			if (vm.meta.transaction_type) chips.push({ key: "transaction_type", label: "Type", value: vm.meta.transaction_type });
			if (vm.meta.status) chips.push({ key: "status", label: "Status", value: vm.meta.status });
			if (vm.meta.customer_id) chips.push({ key: "customer", label: "Customer", value: vm.meta.customer_name || vm.meta.customer_id });
			if (vm.meta.user_id) {
				const user = vm.users.find((u) => u.user_id == vm.meta.user_id);
				chips.push({ key: "user_id", label: "User", value: user?.name || vm.meta.user_id });
			}
			if (vm.meta.payment_mode_id) {
				const mode = vm.payment_modes.find((m) => m.payment_mode_id == vm.meta.payment_mode_id);
				chips.push({ key: "payment_mode_id", label: "Mode", value: mode?.payment_mode || vm.meta.payment_mode_id });
			}
			if (vm.meta.branch_id) {
				const branch = vm.branches.find((b) => b.branch_id == vm.meta.branch_id);
				chips.push({ key: "branch_id", label: "Branch", value: branch?.branch_name || vm.meta.branch_id });
			}
			return chips;
		},

		activeFilterCount() {
			return this.activeFilterChips.length;
		},

		paginationTo() {
			if (!this.meta.totalRows) {
				return this.meta.from;
			}
			const to = this.meta.from + this.transactions.length - 1;
			return Math.min(to, this.meta.totalRows);
		},
	},

	methods: {
		formatCurrency(amount) {
			// Convert number to Indian standard currency format
			const formattedAmount = new Intl.NumberFormat("en-IN", {
				style: "currency",
				currency: "INR",
			}).format(amount);

			return formattedAmount;
		},

		statusBadgeClass(status) {
			if (status === "Approved") return "badge-success";
			if (status === "Rejected") return "badge-danger";
			if (status === "Pending") return "badge-warning";
			return "badge-secondary";
		},

		typeCardClass(transactionType) {
			const map = {
				Deposit: "txn-card--deposit",
				Withdraw: "txn-card--withdraw",
				BuyIn: "txn-card--buyin",
				CashOut: "txn-card--cashout",
				TDS: "txn-card--tds",
			};
			return map[transactionType] || "txn-card--default";
		},

		customerInitial(transaction) {
			const name = transaction?.customer?.customer_name;
			if (name) return name.charAt(0).toUpperCase();
			const no = transaction?.customer?.customer_no;
			if (no) return String(no).charAt(0).toUpperCase();
			return "";
		},
		index() {
			let vm = this;
			vm.listLoading = true;
			vm.$store
				.dispatch("post", { uri: "paginateTransactions", data: vm.meta })
				.then(function (response) {
					vm.transactions = response.data.data;
					vm.meta.totalRows = response.data.meta.total;
					vm.meta.lastPage = response.data.meta.last_page;
					vm.meta.from = response.data.meta.from;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
					vm.getSumOfTransactions();
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				})
				.finally(function () {
					vm.listLoading = false;
				});
		},

		getSumOfTransactions() {
			let vm = this;
			let uri = { uri: "transactions/getSumOfTransactions", data: vm.meta };
			vm.$store
				.dispatch("post", uri)
				.then(function (response) {
					vm.total = response.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		view_transaction(transaction) {
			this.$refs.transactionModal.open(transaction.transaction_id);
		},

		onTransactionUpdated(updated) {
			const id = updated.transaction_id;
			const idx = this.transactions.findIndex((t) => t.transaction_id == id);
			if (idx === -1) {
				return;
			}
			const current = this.transactions[idx];
			this.transactions[idx] = {
				...current,
				status: updated.status ?? current.status,
				amount: updated.amount ?? current.amount,
				customer: updated.customer || current.customer,
				payment_mode: updated.payment_mode || current.payment_mode,
				user: updated.user || current.user,
			};
		},

		getUsers() {
			let vm = this;
			if (vm.$store.getters.branch_users.length > 0) {
				vm.users = vm.$store.getters.branch_users;
				vm.getPaymentModes();
			} else {
				let uri = { uri: "getBranchUsers", data: vm.meta };
				vm.$store
					.dispatch("post", uri)
					.then(function (response) {
						vm.users = response.data.data;
						vm.$store.dispatch("setBranchUsers", vm.users);
						vm.getPaymentModes();
					})
					.catch(function (error) {
						vm.errors = error.response.data.errors;
						vm.$store.dispatch("error", error.response.data.message);
					});
			}
		},
		getPaymentModes() {
			let vm = this;
			if (this.$store.getters.payment_modes.length) {
				vm.payment_modes = vm.$store.getters.payment_modes;
			} else {
				let uri = { uri: "paymentModes" };
				vm.$store
					.dispatch("post", uri)
					.then(function (response) {
						vm.payment_modes = response.data.data;
						vm.$store.dispatch("setPaymentModes", vm.payment_modes);
					})
					.catch(function (error) {
						vm.errors = error.response.data.errors;
						vm.$store.dispatch("error", error.response.data.message);
					});
			}
		},
		getBranches() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getBranches" })
				.then(function (response) {
					vm.branches = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		updateBankStatus(transaction_id) {
			let vm = this;
			let data = {
				transaction_id: transaction_id,
			};
			let uri = { uri: "updateTransactionBankStatus", data: data };
			vm.$store.dispatch("post", uri);
		},

		updatePosStatus(transaction_id) {
			let vm = this;
			let data = {
				transaction_id: transaction_id,
			};
			let uri = { uri: "updateTransactionPosStatus", data: data };
			vm.$store.dispatch("post", uri);
		},

		changeTransactionType(event) {
			let vm = this;
			console.log("11", vm.meta.transaction_type);
			console.log("22", event.target.value);

			vm.meta.transaction_type = event.target.value;

			vm.index();
		},

		changeStatus(event) {
			let vm = this;
			vm.meta.status = event.target.value;
			vm.index();
		},

		changeFromDate(event) {
			let vm = this;
			vm.meta.from_date = event.target.value;
			vm.index();
		},

		changeToDate(event) {
			let vm = this;
			vm.meta.to_date = event.target.value;
			vm.index();
		},

		changeCustomer() {
			let vm = this;
			vm.customers.filter((customer) => {
				customer.customer_id == vm.meta.customer_id;
				vm.index();
			});
		},

		changeUser() {
			let vm = this;
			console.log("1", vm.meta.user_id);
			vm.users.filter((user) => {
				user.user_id == vm.meta.user_id;
				vm.index();
			});
		},
		changePaymentMode() {
			let vm = this;
			vm.payment_modes.filter((payment_mode) => {
				payment_mode.payment_mode_id == vm.meta.payment_mode_id;
				vm.index();
			});
		},

		onPageChange(page) {
			this.meta.page = page;
			this.index();
		},

		selectCustomer(e) {
			let vm = this;
			const customer = e.target.value;
			vm.meta.customer_id = customer.customer_id;
			vm.meta.customer_name = customer.customer_no + ' - ' + customer.customer_name;
			// vm.index();
		},

		downloadTransaction() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "downloadTransactions", data: vm.meta })
				.then(function (response) {
					vm.$store.dispatch("success", response.data.message);
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		search() {
			let vm = this;
			vm.meta.page = 1;
			vm.index();
		},
		clearFilter(key) {
			const vm = this;
			if (key === "from_date") vm.meta.from_date = "";
			else if (key === "to_date") vm.meta.to_date = "";
			else if (key === "transaction_type") vm.meta.transaction_type = "";
			else if (key === "status") vm.meta.status = "";
			else if (key === "customer") {
				vm.meta.customer_id = "";
				vm.meta.customer_name = "";
			} else if (key === "user_id") vm.meta.user_id = "";
			else if (key === "payment_mode_id") vm.meta.payment_mode_id = "";
			else if (key === "branch_id") vm.meta.branch_id = vm.$store.getters.user.branch_id;
			vm.meta.page = 1;
			vm.index();
		},

		resetSearch() {
			let vm = this;
			vm.meta.from_date = "";
			vm.meta.to_date = "";
			vm.meta.transaction_type = "";
			vm.meta.customer_name = "";
			vm.meta.customer_id = "";
			vm.meta.status = "";
			vm.meta.user_id = "";
			vm.meta.payment_mode_id = "";
			vm.meta.search = "";
			vm.meta.branch_id = vm.$store.getters.user.branch_id;
			vm.errors = [];
			vm.index();
		},
		sort(field) {
			if (this.meta.keyword === field) {
				this.meta.order_by = this.meta.order_by === "asc" ? "desc" : "asc";
			} else {
				this.meta.keyword = field;
				this.meta.order_by = field === "transaction_date_time" ? "desc" : "asc";
			}
			this.index();
		},

		sortPillClass(field) {
			return {
				"txn-sort-pill--active": this.meta.keyword === field,
				"txn-sort-pill--asc": this.meta.keyword === field && this.meta.order_by === "asc",
				"txn-sort-pill--desc": this.meta.keyword === field && this.meta.order_by === "desc",
			};
		},

		sortIconClass(field) {
			if (this.meta.keyword !== field) {
				return "fas fa-sort txn-sort-pill__icon txn-sort-pill__icon--idle";
			}
			return this.meta.order_by === "asc"
				? "fas fa-sort-up txn-sort-pill__icon"
				: "fas fa-sort-down txn-sort-pill__icon";
		},

		validateDateRange() {
			const { from_date, to_date, status } = this.meta;
			if (!from_date || !to_date) {
				alert("Please select 'From Date,' 'To Date,' 'Transaction Type,' and 'Status.'");
				return;
			}

			const fromDate = new Date(from_date);
			const toDate = new Date(to_date);
			const dayDifference = (toDate - fromDate) / (1000 * 60 * 60 * 24);

			if (dayDifference < 0) {
				alert('"To Date" cannot be earlier than "From Date".');
				return;
			}

			if (dayDifference > 366) {
				alert("The date range cannot exceed 366 days.");
				return;
			}

			// if (!transaction_type) {
			//     alert("Please select a valid Transaction Type.");
			//     return;
			// }

			if (!status) {
				alert("Please select a valid Status.");
				return;
			}
			window.location.href = this.downloadUrl;
		},
	},
};
</script>

<style scoped>
.txn-page {
	display: flex;
	flex-direction: column;
	height: calc(100vh - 57px);
	max-height: calc(100vh - 57px);
	overflow: hidden;
}

.txn-page__breadcrumb {
	flex-shrink: 0;
	margin-bottom: 0;
}

.txn-page__content {
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: hidden;
}

.txn-page__container,
.txn-page__row,
.txn-page__col {
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: hidden;
}

.txn-page__card {
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: hidden;
}

.txn-page__body {
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: hidden;
}

.txn-page__filters {
	flex-shrink: 0;
}

.txn-page__footer {
	flex-shrink: 0;
	background: #f8f9fa;
	border-top: 1px solid #e9ecef;
}

.txn-pagination-bar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	width: 100%;
}

.txn-pagination-bar__info strong {
	color: #343a40;
	font-weight: 600;
}

.txn-list-header {
	flex-shrink: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.txn-list-header .card-title {
	font-size: 1rem;
}

.txn-list-header__actions {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
	margin-left: auto;
}

.txn-total-inline {
	font-size: 0.8rem;
	color: #6c757d;
	white-space: nowrap;
}

.txn-total-inline strong {
	color: #155724;
	font-size: 0.9rem;
}

.txn-sort-pills {
	display: inline-flex;
	flex-wrap: wrap;
	gap: 4px;
}

.txn-sort-pill {
	display: inline-flex;
	align-items: center;
	gap: 3px;
	padding: 2px 8px;
	font-size: 0.72rem;
	font-weight: 500;
	color: #495057;
	background: #f8f9fa;
	border: 1px solid #dee2e6;
	border-radius: 4px;
	cursor: pointer;
}

.txn-sort-pill--active {
	background: #007bff;
	border-color: #007bff;
	color: #fff;
}

.txn-sort-pill__icon {
	font-size: 0.65rem;
}

.txn-sort-pill__icon--idle {
	opacity: 0.4;
}

.txn-filters {
	margin-bottom: 4px;
	flex-shrink: 0;
}

.txn-filters__bar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 6px;
	width: 100%;
}

.txn-filters__toggle {
	white-space: nowrap;
}

.txn-filters__search {
	position: relative;
	flex: 1 1 140px;
	min-width: 120px;
	max-width: 280px;
}

.txn-filters__search-icon {
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 0.8rem;
	color: #adb5bd;
	pointer-events: none;
	z-index: 1;
}

.txn-filters__search .form-control {
	padding-left: 1.75rem;
	height: 30px;
	font-size: 0.8rem;
}

.txn-filters__bar-actions {
	display: flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
}

.txn-filters__chips {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	margin-top: 4px;
}

.txn-filter-chip {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 0.7rem;
	padding: 2px 6px;
	background: #f1f3f5;
	border: 1px solid #e9ecef;
	border-radius: 4px;
}

.txn-filter-chip__label {
	font-weight: 600;
	color: #6c757d;
	font-size: 0.65rem;
}

.txn-filter-chip__value {
	color: #212529;
	max-width: 120px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.txn-filter-chip__clear {
	border: none;
	background: transparent;
	padding: 0 2px;
	margin: 0;
	line-height: 1;
	font-size: 0.9rem;
	color: #6c757d;
	cursor: pointer;
}

.txn-filter-chip__clear:hover {
	background: #fde8e8;
	color: #dc3545;
}

.txn-filters__panel {
	margin-top: 6px;
	padding: 8px;
	background: #f8f9fa;
	border: 1px solid #e9ecef;
	border-radius: 6px;
}

.txn-filters__grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(118px, 1fr));
	gap: 6px 8px;
	align-items: start;
}

.txn-filters__field {
	min-width: 0;
}

.txn-filters__field--wide {
	grid-column: span 2;
}

@media (max-width: 400px) {
	.txn-filters__field--wide {
		grid-column: span 1;
	}
}

.txn-filters__field--wide .customer,
.txn-filters__field--wide .customer-inner,
.txn-filters__field--wide .form-control {
	width: 100%;
}

.txn-filters__label {
	display: block;
	font-size: 0.62rem;
	font-weight: 600;
	text-transform: uppercase;
	color: #868e96;
	margin-bottom: 2px;
	line-height: 1;
}

.txn-filters__field .form-control-sm {
	width: 100%;
	height: 30px;
	padding: 2px 6px;
	font-size: 0.8rem;
}

.transaction-card-list {
	flex: 1 1 auto;
	min-height: 0;
	overflow-x: hidden;
	overflow-y: auto;
	width: 100%;
	-webkit-overflow-scrolling: touch;
}

.txn-card-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	gap: 8px;
	width: 100%;
	max-width: 100%;
}

.txn-card-grid__item {
	min-width: 0;
	max-width: 100%;
}

.txn-empty {
	text-align: center;
	padding: 2rem 1rem;
}

.txn-card {
	background: #fff;
	border-radius: 8px;
	border: 1px solid #e3e6ea;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
	height: 100%;
	display: flex;
	flex-direction: column;
	padding: 10px 12px 8px;
	border-top: 3px solid #6c757d;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	box-sizing: border-box;
}

.txn-card--deposit { border-top-color: #28a745; }
.txn-card--withdraw { border-top-color: #dc3545; }
.txn-card--buyin { border-top-color: #007bff; }
.txn-card--cashout { border-top-color: #17a2b8; }
.txn-card--tds { border-top-color: #ffc107; }
.txn-card--default { border-top-color: #6c757d; }

.txn-card__top {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 8px;
	margin-bottom: 4px;
	min-width: 0;
}

.txn-card__badges {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 5px;
	min-width: 0;
	flex: 1;
}

.txn-type {
	font-size: 0.68rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	color: #495057;
	background: #f1f3f5;
	padding: 2px 7px;
	border-radius: 4px;
}

.txn-card__amount {
	font-size: 0.95rem;
	font-weight: 700;
	color: #212529;
	line-height: 1.2;
	text-align: right;
	flex-shrink: 0;
	max-width: 50%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.txn-card--clickable {
	cursor: pointer;
	transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.txn-card--clickable:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	border-color: #c8ced3;
}

.txn-card__no {
	font-size: 0.9rem;
	font-weight: 600;
	color: #007bff;
	display: block;
	line-height: 1.3;
}

.txn-card__index {
	font-size: 0.68rem;
	margin-bottom: 8px;
}

.txn-card__customer {
	display: flex;
	align-items: center;
	gap: 6px;
	background: #f8f9fa;
	border-radius: 6px;
	padding: 6px 8px;
	margin-bottom: 8px;
	min-width: 0;
}

.txn-card__avatar {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: linear-gradient(135deg, #007bff, #0056b3);
	color: #fff;
	font-weight: 700;
	font-size: 0.9rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.txn-card__customer-text {
	min-width: 0;
	flex: 1;
	overflow: hidden;
}

.txn-card__cust-no {
	font-size: 0.88rem;
	font-weight: 700;
	color: #212529;
	line-height: 1.2;
}

.txn-card__cust-name {
	font-size: 0.75rem;
	color: #6c757d;
	margin-top: 1px;
}

.txn-card__details {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 6px 10px;
	margin-bottom: 6px;
}

.txn-detail--full {
	grid-column: 1 / -1;
}

.txn-detail__label {
	display: block;
	font-size: 0.62rem;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	color: #adb5bd;
	font-weight: 600;
	margin-bottom: 1px;
}

.txn-detail__value {
	display: block;
	font-size: 0.75rem;
	color: #343a40;
	font-weight: 500;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
}

.txn-card__note {
	font-size: 0.72rem;
	color: #6c757d;
	background: #fff8e6;
	border-left: 3px solid #ffc107;
	padding: 5px 8px;
	border-radius: 0 4px 4px 0;
	margin-bottom: 8px;
}

.txn-card__footer {
	margin-top: auto;
	padding-top: 2px;
}

.txn-card__footer .btn {
	font-size: 0.78rem;
	padding: 4px 8px;
}

.txn-card--skeleton {
	pointer-events: none;
	border-top-color: #e9ecef;
	cursor: default;
}

.txn-card__customer--skeleton {
	display: flex;
	align-items: center;
	gap: 8px;
	background: #f8f9fa;
	border-radius: 6px;
	padding: 8px 10px;
}

.txn-skeleton {
	display: block;
	background: linear-gradient(90deg, #e9ecef 0%, #f5f6f8 50%, #e9ecef 100%);
	background-size: 200% 100%;
	animation: txn-skeleton-shimmer 1.2s ease-in-out infinite;
	border-radius: 4px;
}

.txn-skeleton--badge {
	width: 72px;
	height: 18px;
}

.txn-skeleton--amount {
	width: 80px;
	height: 20px;
}

.txn-skeleton--line {
	width: 100%;
	height: 14px;
}

.txn-skeleton--line-sm {
	width: 55%;
	height: 12px;
}

.txn-skeleton--avatar {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	flex-shrink: 0;
}

.txn-skeleton--detail {
	height: 28px;
	border-radius: 4px;
}

@keyframes txn-skeleton-shimmer {
	0% {
		background-position: 200% 0;
	}

	100% {
		background-position: -200% 0;
	}
}
</style>
